import React, { Component } from 'react';
import { graphql, withApollo } from 'react-apollo';
import { Table, Button, notification, Modal, Input } from 'antd';
import AntIcon from '../shared/components/AntIcon';

import { ListTagsQuery, DeleteModelTagMutation, CreateModelTagMutation } from './queries';

const Columns = (handleDelete) => [
  {
    title: '# Tag',
    dataIndex: 'title',
    defaultSortOrder: 'descend',
    sorter: (a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()),
  },
  {
    title: "Actions",
    dataIndex: '_id',
    render: (id) => (
      <Button ghost type="danger" on Click={() => handleDelete(id)}>
        <AntIcon type="delete" />Delete
      </Button>
    ),
  }
];

class List extends Component {
  state = {
    modalVisible: false,
    newTagWord: "",
    newTagColor: "",
  }

  handleDelete = (id) => {
    const { client, data: { refetch } } = this.props;
    client.mutate({
      mutation: DeleteModelTagMutation,
      variables: { query: { _id: id } },
    }).then(refetch);
  }

  handleCreate = () => {
    const { client, data: { refetch } } = this.props;
    const { newTagWord } = this.state;

    client.mutate({
      mutation: CreateModelTagMutation,
      variables: { keyword: { title: newTagWord } },
    })
    .then(() => {
      refetch();
      this.setState({ 
        modalVisible: false,
        tag: "",
      });
    })
    .catch(error => {
      if (error.message.endsWith("Validation failed")) {
        return notification.error({ message: "Tag is already exists" });
      }
      notification.error(error);  
    });
  }

  render() {
    const { newTagWord, modalVisible } = this.state;
    const { loading, error, ModelTags } = this.props.data;
    if (error) return `Error: ${error}`;

    return (
      <div id="keywords-list">
        <div className="container">
          <h4>
            ModelTags
            <Button.Group size="small" className="is-right">
              <Button onClick={() => this.setState({ modalVisible: true })} icon="plus">New tag</Button>
            </Button.Group>
          </h4>
          <Table
            scroll={{ x: 1000 }}
            loading={loading}
            columns={Columns(this.handleDelete)}
            rowKey='_id'
            dataSource={ModelTags}
          />
          <Modal
            title="Add New Tag"
            open={modalVisible}
            onOk={this.handleCreate}
            okText="Add"
             onCancel={() => this.setState({ modalVisible: false })}
          >
            <Input
              className="container__input"
              value={newTagWord} 
              onChange={(event) => this.setState({ newTagWord: event.target.value })}
              placeholder="Tag Name"
            />
            {/* <Input
              value={newTagColor} 
              onChange={(event) => this.setState({ newTagColor: event.target.value })}
              placeholder="Keyword"
            /> */}
          </Modal>
        </div>
      </div>
    );
  }
}

export default withApollo(graphql(ListTagsQuery, { options: { fetchPolicy: 'no-cache' } })(List));
